import { create } from "zustand";

const useFormRespostaPropostaStore = create((set, get) => ({
    forms: {},
    errors: {},

    setFormData: (propostaId, data) =>
        set(state => ({
            forms: {
                ...state.forms,
                [propostaId]: data
            }
        })),

    getFormData: (propostaId) =>
        get().forms[propostaId] || {},

    setErrors: (fieldName, errorMsg) =>
        set(state => ({
            errors: {
                ...state.errors,
                [fieldName]: errorMsg
            }
        })),

    getErrors: (fieldName) => {
        return get().errors[fieldName] || "";
    }
}));

export { useFormRespostaPropostaStore };